module.exports = __webpack_public_path__ + "static/img/Siti Balqis-full.70ff55e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/full/Siti Balqis-full.png
// module id = gYpH
// module chunks = 1